<template>
  <div>
    <div
      class="
        md:flex md:md:align-baseline
        w-full
        relative
        border-b-4 border-red-600
      "
    >
      <div class="w-32">
        <template>
          <button class="outline-none focus:outline-none" @click="dashboard">
            <img
              class="md:w-24 w-24 ml-6"
              src="../assets/images/logo2.png"
              alt=""
            />
          </button>
        </template>
      </div>
      <div
        class="
          font-sans font-light
          text-3xl text-black
          md:items-center md:flex md:justify-center
          w-full
        "
      >
        <div class="text-3xl">MOLDEX BUYER'S PORTAL</div>
        <div class="md:flex items-center justify-end absolute right-0 px-10">
          <v-btn small text @click="onPressMyAccount">
            <v-icon small>mdi-account-outline</v-icon>
            My Account</v-btn
          >

          <v-btn text small @click="signout">
            <v-icon small>mdi-logout</v-icon> Sign out</v-btn
          >
        </div>
      </div>
    </div>
    <!-- <div>
      <div class="sm:flex justify-center mt-2 mb-4">
        <div class="sm:flex w-1/2 ml-28 min-w-[300px]">
          <v-btn
            to="/home/buyers-guide-billing-payments"
            dark
            class="mr-4 text-left w-1/4]"
            color="#1F387D"
          >
            <span class="text-xs">Billing Payments</span>
          </v-btn>
          <v-btn
            to="/home/buyers-guide-financing-scheme-payments"
            dark
            class="mr-4 w-1/4"
            color="#1F387D"
          >
            <span class="text-xs">Financing Scheme</span>
          </v-btn>
          <v-btn
            to="/home/buyers-guide-move-in"
            dark
            class="w-1/4 mr-4"
            color="#1F387D"
          >
            <span class="text-xs">Move-in Turnover</span>
          </v-btn>
          <v-btn
            to="/home/buyers-guide-title-transfer"
            dark
            class="mr-4 w-1/4"
            color="#1F387D"
          >
            <span class="text-xs">Title Transfer</span>
          </v-btn>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import logout from "../utils/logout";
import SecureStorage from "../utils/secureStorage";

export default {
  data() {
    return {};
  },

  methods: {
    onPressMyAccount() {
      this.$router.push({
        path: "/home/my-account",
        query: {
          cc: this.$route.query.cc,
          cn: this.$route.query.cn,
        },
      });
    },
    signout() {
      logout();
    },
    dashboard() {
      if (SecureStorage.getItem("auth").role == "admin") {
        if ("/admin" != this.$route.path) {
          this.$router.push({ name: "Admin Page" });
        }
      } else {
        if ("/home/dashboard" != this.$route.path) {
          this.$router.push({
            path: "/home/dashboard",
            query: {
              cc: this.$route.query.cc,
              cn: this.$route.query.cn,
            },
          });
        }
      }
    },
  },
};
</script>
